import axios from "axios";
import { appEnv } from "../appEnv";
import { setTokenRequestInterceptor } from "./interceptors";

const apiLogs = axios.create({
  baseURL: appEnv.REACT_APP_OCPP_LOGS_API_URL,
  params: {
    tupi_cache_purge: Date.now(),
  },
});

apiLogs.interceptors.request.use(setTokenRequestInterceptor);

export default apiLogs;
